// Bloomberg BICS level-1 names, keyed by the first two digits of Party.industryCode.
// Same mapping as packages/nodejobapi/src/jobs/fund-key-measures/bics.json.
const BICS_LEVEL_1: Record<string, string> = {
    "10": "Communications",
    "11": "Consumer Discretionary",
    "12": "Consumer Staples",
    "13": "Energy",
    "14": "Financials",
    "15": "Real Estate",
    "16": "Health Care",
    "17": "Industrials",
    "18": "Materials",
    "19": "Technology",
    "20": "Utilities",
    "50": "Government"
};

export const OTHER_SECTOR = "Other";

export const industryCodeToSector = (industryCode: string | null | undefined): string => {
    if (!industryCode) {
        return OTHER_SECTOR;
    }
    const digits = String(industryCode).replace(/\D/g, "");
    if (digits.length < 2) {
        return OTHER_SECTOR;
    }
    const sector = BICS_LEVEL_1[digits.substring(0, 2)];
    if (!sector) {
        return OTHER_SECTOR;
    }
    return sector;
};
